  @if (data) {
  <div class="container">
    <div class="close-icon">
      <mat-icon (click)="snackBarRef.dismiss()" class="actions" matTooltip="Close">close</mat-icon>
    </div>

    <div class="snack-bar-summary">
      @switch (data.snackBarTheme) {
        @case (snackBarIconTypes.INFO) {
          <mat-icon class="icon">info</mat-icon>
        }
        @case (snackBarIconTypes.SUCCESS) {
          <mat-icon class="icon">verified</mat-icon>
        }
        @case (snackBarIconTypes.ERROR) {
          <mat-icon class="icon">error</mat-icon>
        }
        @case (snackBarIconTypes.WARNING) {
          <mat-icon class="icon">warning</mat-icon>
        }
      }

      @if (data.snackBarSummary) {
        <span class="summary-text">{{ data.snackBarSummary }}</span>
      }
    </div>

    @if (data.snackBarDetail) {
      <div class="snack-bar-detail">
        {{ data.snackBarDetail }}
      </div>
    }

    @if (data.snackBarDetailList) {
      <div class="snack-bar-detail">
        <ul>
          @for (detail of data.snackBarDetailList; track detail) {
            <li>{{ detail }}</li>
          }
        </ul>
      </div>
    }
  </div>
}